<ng-container *ngIf="window && window.innerWidth > 991">
  <div class="thumbs">
    <div
      [ngClass]="{ active: _image === image }"
      class="thumb"
      (click)="scrollToImage(image, index)"
      *ngFor="let image of product.images; let index = index"
    >
      <img
        width="32"
        height="32"
        [ngSrc]="image.src"
        [loaderParams]="{ aspect: 1 }"
      />
    </div>
  </div>
  <div class="images g-1 row pb-5">
    <div
      #image
      class="position-relative"
      *ngFor="let image of product.images; let index = index; let first = first"
      [ngClass]="[_classes[index] ?? '']"
    >
      <div
        class="image"
        [ngClass]="{
          first: first,
          nopad:
            product.product_type.includes('Leather Sleeve') ||
            product.title.includes('Smiley Cup')
        }"
      >
        <img
          *ngIf="
            product.product_type.toLowerCase().includes('cup') && index == 0
          "
          class="gooddesign"
          src="/assets/gooddesign.png"
        />
        <img
          fill
          *ngIf="_sleeve?.images && first"
          class="sleeve"
          [ngSrc]="
            product.title.includes('Grande')
              ? _sleeve.images[0]
              : _sleeve.images[0]
          "
          [loaderParams]="{ aspect: 1 }"
          sizes="(max-width: 991px) 100vw, 50vw"
        />
        <img
          [ngStyle]="{
            backgroundColor: first
              ? 'none'
              : product.metafields?.product?.image_background_colour ??
                'rgba(0,0,0,.05)'
          }"
          class="hero w-100 h-auto"
          [width]="760"
          height="720"
          [priority]="first"
          [ngSrc]="image.src"
          [loaderParams]="{ aspect: 1 }"
          sizes="(max-width: 991px) 100vw, 50vw"
        />
      </div>
    </div>
  </div>
</ng-container>
